import {useNavigate} from 'react-router-dom';
import {Button} from '@carbon/react';
import {Locked} from '@carbon/icons-react';
import checkAccess, {SiteFeature} from '../lib/check-access';

type Props = {
    children: JSX.Element,
    siteFeature: SiteFeature,
    accessDeniedMessage?: string,
    returnPath?: string,
}

export default function AccessWall(props: Props): JSX.Element {
    const hasAccess = checkAccess(props.siteFeature);
    const navigate = useNavigate();

    if (!hasAccess) {
        return (
            <div className='flex items-center justify-center min-h-[calc(100vh-8rem)] bg-gray-50 px-4'>
                <div className='max-w-lg w-full'>
                    <div className='bg-white rounded-lg shadow-md border border-gray-200 p-8 md:p-12'>
                        <div className='flex flex-col items-center text-center'>
                            {/* Icon */}
                            <div className='p-3 bg-blue-50 rounded-full'>
                                <Locked size={56} className='text-blue-600' />
                            </div>

                            {/* Heading */}
                            <h1 className='text-3xl font-semibold text-gray-900 mb-4'>
                                Access Restricted
                            </h1>

                            {/* Message */}
                            <div className='text-base leading-relaxed text-gray-700 font-medium mb-10 max-w-md'>
                                {props.accessDeniedMessage ||
                                    'You do not have permission to access this feature. Please contact your administrator or customer support for assistance.'}
                            </div>

                            {/* Action Button */}
                            <Button
                                onClick={() => navigate(props.returnPath || '/')}
                                kind='primary'
                                size='lg'
                            >
                                Return to Home
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return props.children;
}
